<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <CRow class="float-right mb-2">
            <div class="search-list">
              <CCol sm="12">
                <CInput
                  class="float-left mb-0 mr-2"
                   placeholder="Search By Letter Code"
                  v-model="searchContent"
                  @input="searchConsol('')"
                >
                  <template #prepend-content>
                    <CIcon name="cil-magnifying-glass" />
                  </template>
                </CInput>
              </CCol>
            </div>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="100"
            clickable-rows
            :active-page="1"
            :pagination="false"
            @page-change="pageChange"
          ></CDataTable>
          <div class="pagination-nav">
            <div
              class="pagination-btn-refresh"
              @click="searchConsol('REFRESH')"
            >
              Refresh
            </div>
            <div class="pagination-btn-back" @click="searchConsol('BACK')">
              back
            </div>
            <div class="pagination-page-title">{{ activePage }}</div>
            <div class="pagination-btn-next" @click="searchConsol('NEXT')">
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";

export default {
  name: "Province",
  data() {
    return {
      items: [],
      searchContent: "",
      fields: [
        { key: "consol_id", label: "ID" },
        { key: "consol_name", label: "Nama Konsol" },
        { key: "latter_code", label: "Letter Code" },
        { key: "address", label: "Alamat" },
        { key: "contact_number", label: "Telephone" },
      ],
      activePage: 1,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
    this.searchConsol("");
  },

  beforeMount() {},
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    searchConsol(action) {
      if (action === "NEXT") {
        this.activePage = this.activePage + 1;
      } else if (action === "BACK") {
        if (this.activePage > 1) {
          this.activePage = this.activePage - 1;
          window.scrollTo(0, 0);
        }
      } else if (action === "REFRESH") {
        this.activePage = 1;
        window.scrollTo(0, 0);
      } else {
        this.activePage = 1;
      }
      axios
        .get(
          `${this.domain}/v1/consolidator/data?page=${this.activePage}&per_page=100&q=${this.searchContent}`,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.data.length > 0) {
            if (this.activePage > 1) {
              window.scrollTo(0, 0);
            }
            this.items = response.data.data;
          } else if (action === "NEXT") {
            this.activePage = this.activePage - 1;
          } else if (response.data.data.length === 0 && action === "") {
            this.items = response.data.data;
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
@import url("../../agent_registration/Agent.css");
</style>
